<template>
  <div class="pa-4 form-component">
    <div class="d-flex justify-space-between align-center">
      <label>Images ({{ $parent.attributes.images.length }}/255)</label>
      <a class="link-add" @click="showModelAddImage = true"> Add image from URL</a>
    </div>
    <UploadMultiple
      :columns="{ lg: 4, md: 4, sm: 6, xs: 12 }"
      :images="$parent.attributes.images"
      @callback="getImageUpLoad"
      @deleteCallback="getDeleteCallback"
    />
    <v-dialog persistent v-model="showModelAddImage" width="500">
      <v-card class="pa-4">
        <div class="d-flex align-center justify-space-between mb-4">
          <h2 class="mb-0">Add link image</h2>
          <v-btn icon @click="showModelAddImage = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-text-field
          type="url"
          :error-messages="messageCheckImage"
          v-model="linkImage"
          placeholder="https://"
          hide-details=""
        ></v-text-field>
        <div class="d-flex justify-end mt-4">
          <v-btn color="primary" depressed @click="submit">Save</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModelAddImage: false,
      messageCheckImage: '',
      linkImage: '',
    };
  },
  methods: {
    async checkImage(url) {
      var pattern = new RegExp(/^https?:\/\/.*\/.*\.(png|gif|webp|jpeg|jpg|webp)\??.*$/gim); // fragment locator
      return !!pattern.test(url);
    },
    objectId() {
      return this.hex(Date.now() / 1000) + ' '.repeat(16).replace(/./g, () => this.hex(Math.random() * 16));
    },

    hex(value) {
      return Math.floor(value).toString(16);
    },
    async submit() {
      this.messageCheckImage = '';
      let check = await this.checkImage(this.linkImage);
      console.log('check', check);
      if (check) {
        let obj = {
          alt: '',
          alt_text: '',
          src: this.linkImage,
          _id: this.objectId(),
        };
        this.linkImage = '';
        this.showModelAddImage = false;
        this.$parent.attributes.images.push(obj);
      } else {
        this.messageCheckImage = 'Url Error';
      }
    },
    getImageUpLoad(obj) {
      this.$parent.attributes.images.push(obj);
    },
    getDeleteCallback(key) {
      if (this.$route.params.id) {
        this.$parent.attributes.deleteImageIds.push(this.$parent.attributes.images[key]._id);
      }
      this.$parent.attributes.images.splice(key, 1);
    },
  },
};
</script>
<style lang=""></style>
